import { Routes } from '@angular/router';
import { authGuard } from './guards/auth.guard';

export const routes: Routes = [
  // root route
  { path: '', redirectTo: 'home', pathMatch: 'full' },

  // backwards-compat redirects
  { path: 'nola-driver', redirectTo: 'home/nola-driver', pathMatch: 'full' },
  { path: 'balt-driver', redirectTo: 'home/balt-driver', pathMatch: 'full' },
  { path: 'stg-driver', redirectTo: 'home/stg-driver', pathMatch: 'full' },

  // auth route
  {
    path: 'auth',
    loadComponent: () => import('./pages/dynamic/auth/auth.page').then((m) => m.AuthPage),
  },

  // dynamic public routes
  {
    path: 'incident-request-search',
    loadComponent: () =>
      import('./pages/dynamic/incident-request-search/incident-request-search.page').then(
        (m) => m.IncidentRequestSearch,
      ),
  },
  {
    path: 'incident-request-detail/:id/:accessToken',
    loadComponent: () =>
      import('./pages/dynamic/incident-request-detail/incident-request-detail.page').then(
        (m) => m.IncidentRequestDetailPage,
      ),
  },

  // dynamic admin routes
  {
    path: 'admin/incident-request-search',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./pages/dynamic/admin-incident-request-list/admin-incident-request-list.page').then(
        (m) => m.AdminIncidentRequestListPage,
      ),
  },
  {
    path: 'admin/incident-request-detail/:id',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./pages/dynamic/admin-incident-request-detail/admin-incident-request-detail.page').then(
        (m) => m.AdminIncidentRequestDetailPage,
      ),
  },

  // public dashboards
  {
    path: 'nopd',
    loadComponent: () =>
      import('./pages/dynamic/nola-public-dashboard/nola-public-dashboard.component').then(
        (m) => m.NolaPublicDashboardComponent,
      ),
  },
  {
    path: 'sgpd',
    loadComponent: () =>
      import('./pages/dynamic/stg-public-dashboard/stg-public-dashboard.component').then(
        (m) => m.StgPublicDashboardComponent,
      ),
  },

  // home + public info routes
  {
    path: 'home',
    loadComponent: () => import('./pages/static/home/home.page').then((m) => m.HomePage),
    children: [
      { path: '', redirectTo: 'nola-driver', pathMatch: 'full' },
      {
        path: 'nola-driver',
        loadComponent: () =>
          import('./pages/static/nola-public-info/nola-public-info.page').then(
            (m) => m.NolaPublicInfoPage,
          ),
      },
      {
        path: 'balt-driver',
        loadComponent: () =>
          import('./pages/static/balt-public-info/balt-public-info.page').then(
            (m) => m.BaltPublicInfoPage,
          ),
      },
      {
        path: 'stg-driver',
        loadComponent: () =>
          import('./pages/static/stg-public-info/stg-public-info.page').then(
            (m) => m.StgPublicInfoPage,
          ),
      },
    ],
  },

  // wildcard route
  { path: '**', redirectTo: 'home' },
];
